/** ISO `YYYY-MM-DD` for today (local). */
export function todayIsoDate(): string {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function defaultReportDateRange(): { from: string; to: string } {
  const today = todayIsoDate();
  return { from: today, to: today };
}

/** ISO `YYYY-MM-DD` for a date N calendar months before the reference date (local). */
export function isoDateMonthsBefore(months: number, referenceDate: Date = new Date()): string {
  const d = new Date(referenceDate);
  d.setMonth(d.getMonth() - months);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function defaultDashboardDateRange(lookbackMonths: number): { from: string; to: string } {
  const to = todayIsoDate();
  if (lookbackMonths <= 0) {
    return { from: to, to };
  }
  return { from: isoDateMonthsBefore(lookbackMonths), to };
}

export function toIsoDateStart(dateStr: string): string | undefined {
  const trimmed = dateStr.trim();
  if (!trimmed) return undefined;
  return new Date(`${trimmed}T00:00:00`).toISOString();
}

export function toIsoDateEnd(dateStr: string): string | undefined {
  const trimmed = dateStr.trim();
  if (!trimmed) return undefined;
  return new Date(`${trimmed}T23:59:59.999`).toISOString();
}

export function validateReportDateRange(from: string, to: string): string | null {
  const today = todayIsoDate();
  if (from && from > today) return 'fromFuture';
  if (to && to > today) return 'toFuture';
  if (from && to && from > to) return 'fromAfterTo';
  return null;
}
